import ApiService from "@/core/services/ApiService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule, Mutation } from "vuex-module-decorators";
import { User } from "@/store/modules/AuthModule";

export interface StepsForm {
  customer_non_retracted: string;
  customer_non_retracted_carrier: string;
  gestCoRedio: string;
}

@Module
export default class ComplaintModule extends VuexModule {
  hideSubmitButton = false;
  isDropZoneUpload = false;
  stepIndex = 0;
  forceReloadCalendar = false;
  submitForm = false;
  stepsForm = {} as StepsForm;
  get getHideSubmitButton() {
    return this.hideSubmitButton;
  }
  get getIsDropZoneUpload() {
    return this.isDropZoneUpload;
  }

  get getStepIndex() {
    return this.stepIndex;
  }
  get getForceReloadCalendar() {
    return this.forceReloadCalendar;
  }

  get getStepsForm() {
    return this.stepsForm;
  }
  get getSubmitForm() {
    return this.submitForm;
  }
  /**
   * Set show submit button
   */
  @Mutation
  setHideSubmitButton(hideSubmitButton: boolean) {
    this.hideSubmitButton = hideSubmitButton;
  }

  /**
   * Set is dropzone upload
   */
  @Mutation
  setIsDropzoneUpload(isDropZoneUpload: boolean) {
    this.isDropZoneUpload = isDropZoneUpload;
  }
  /**
   * Set submit form
   */
  @Mutation
  setSubmitForm(submitForm: boolean) {
    this.submitForm = submitForm;
  }
  /**
   * Set force reload calendar
   */
  @Mutation
  setForceReloadCalendar(value: boolean) {
    this.forceReloadCalendar = value;
  }
  /**
   * Set step index
   * @returns User
   */
  @Mutation
  setStepIndex(stepIndex: number) {
    this.stepIndex = stepIndex;
  }

  /**
   * set steps form value
   * @returns User
   */
  @Mutation
  setStepsFormAttribute({
    attribute,
    value,
  }: {
    attribute: string;
    value: string;
  }) {
    this.stepsForm[attribute] = value;
  }
  @Action
  [Mutations.SAVE_STEP](data: object) {
    return ApiService.post("complaints/add", data)
      .then(({ data }) => {
        return data;
      })
      .catch(({ response }) => {
        return response;
      });
  }
}
